// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const fromExtractionMaterialTitleMax = 200;

export const FromExtractionMaterial = zod.object({
  "audience": zod.enum(['internal', 'shareable']),
  "file_id": zod.uuid(),
  "material_type": zod.enum(['one_pager', 'executive_deck', 'technical_deck', 'commercial_model', 'demo', 'case_study', 'architecture', 'other']),
  "title": zod.string().min(1).max(fromExtractionMaterialTitleMax)
});

export type FromExtractionMaterial = zod.input<typeof FromExtractionMaterial>;
export type FromExtractionMaterialOutput = zod.output<typeof FromExtractionMaterial>;
